export const SET_AVAILABLE_LANGUAGES = 'SET_AVAILABLE_LANGUAGES';
export const UPDATE_PRIMARY_LANGUAGE = 'UPDATE_PRIMARY_LANGUAGE';
